/** Shared text for a contact that has neither communication channel. */
export const CONTACT_CHANNEL_REQUIRED_MESSAGE = {
  ru: 'Укажите телефон или email для контакта — достаточно одного из них. Ничего не создано.',
  en: 'Please provide a phone number or an email for the contact — either one is enough. Nothing was created.',
} as const;
